import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ICheckSellerRequirements } from '@core/interfaces/check-seller-requirements.interface';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { UserLogged } from 'src/app/login/interfaces/login.interfaces';
import Swal from 'sweetalert2';
import { ApiService } from './api.service';
import { MemoraEventHost } from '@shared/interfaces/event.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _authResult: number = -1;
  private _userLogged: UserLogged = new UserLogged(-1, '', '', '', -1, false, true, true, '', '', -1, '');
  private _userLoggedAsync: BehaviorSubject<UserLogged> = new BehaviorSubject<UserLogged>(this._userLogged);
  isPingAlreadyExecuted = false;

  constructor(private _router: Router, private _api: ApiService, private _translate: TranslateService) { }

  public get authResult(): number {
    return this._authResult;
  }

  public set authResult(value: number) {
    this._authResult = value;
  }

  public get userLogged(): UserLogged {
    return this._userLogged;
  }

  public set userLogged(value: UserLogged) {
    this._userLogged = value;
    this.setUserLogged(value);
  }

  setUserLogged(user: UserLogged) {
    this._userLoggedAsync.next(user);
  }
  
  getUserLogged(): Observable<UserLogged> {
    return this._userLoggedAsync.asObservable();
  }

  public isAuthenticated(): boolean {
    return this._authResult === 1 && this.userLogged.idUser != -1;
  }

  public isToActivate(): boolean {
    return this._authResult === -2 && this.userLogged.idUser != -1;
  }

  public logout(): void {
    this._authResult = -1;
    this._userLogged = new UserLogged(-1, '', '', '', -1, false, true, true, '', '', -1, '');
  }

  public checkSellerRequirements(): Observable<boolean> {
    return this._api.request<ICheckSellerRequirements>(ApiServiceHolder.entityData.hasSellerRequirements(this.userLogged.idEntity)).pipe(
      map(
        criteria => {
          if (!criteria.hasCriteriaOk) {
            if (!criteria.hasFiscalCode || !criteria.hasIban) {
              Swal
                .fire(this._translate.instant(!criteria.hasFiscalCode ? "IDS_INSERT_FISCAL_CODE" : "IDS_ENTER_IBAN"))
                .then(() => this._router.navigate(['account/billing-data']));
            } else if (!criteria.hasBillingAddress) {
              Swal
                .fire(this._translate.instant("IDS_ENTER_BILLING_ADDRESS"))
                .then(() => this._router.navigate(['account/shipping-addresses']));
            }
          }
          return criteria.hasCriteriaOk
        }
      )
    );
  }

  public isUserHost(memoraEventHostList: MemoraEventHost[]): Observable<boolean> {
    return this.getUserLogged().pipe(
      map(user => {
        return (user.idProfile === 1) || 
               (memoraEventHostList?.some(host => host.idHost === user.idUser));
      })
    );
  }
}
